import React from "react";
import { Heart } from "lucide-react";

/** Hányan mentették kedvencek közé — globális számláló. */
export function FavoriteCount({ count = 0, className = "", testid, compact = false }) {
  const n = Math.max(0, Number(count) || 0);
  const label = n === 0
    ? "Még nincs kedvenc"
    : n === 1
      ? "1-en mentette kedvencek közé"
      : `${n} kedvenc`;

  return (
    <span
      data-testid={testid}
      title={n === 0 ? label : `${n} felhasználó mentette kedvencek közé`}
      className={`inline-flex items-center gap-1.5 ${n === 0 ? "text-slate-500" : "text-red-300/90"} ${className}`}
    >
      <Heart className={`${compact ? "w-3 h-3" : "w-3.5 h-3.5"}`} fill={n > 0 ? "currentColor" : "none"} strokeWidth={1.5} />
      <span className={compact ? "text-[10px]" : "text-xs"}>{compact && n > 0 ? n : label}</span>
    </span>
  );
}
